module.exports = __webpack_public_path__ + "static/img/fact.72a70ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fact.png
// module id = HP2r
// module chunks = 1